import Api from './baseApi';

export default {
  getAll: () => Api.get('/api/bankHolidays'),
  get: (id) => Api.get(`/api/bankHolidays/${id}`),
  post: (holiday) => Api.post('/api/bankHolidays', holiday),
  put: (holiday) => Api.put(`/api/bankHolidays/${holiday.id}`, holiday),
  delete: (id) => Api.delete(`/api/bankHolidays/${id}`),
};
